const NavBar = () => {
  return (
    <div className='navbar' style={{ margin: '0', padding: '0' }}>
      <h1 style={{ background: 'green', padding: '1rem 0' }}>
        Student Dashboard
      </h1>
    </div>
  );
};

export default NavBar;
